import { render, staticRenderFns } from "./dialogTest.vue?vue&type=template&id=8f7d875a&scoped=true&"
import script from "./dialogTest.vue?vue&type=script&lang=js&"
export * from "./dialogTest.vue?vue&type=script&lang=js&"
import style0 from "./dialogTest.vue?vue&type=style&index=0&id=8f7d875a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7d875a",
  null
  
)

export default component.exports